import { computed } from 'vue'
import { useQueuesStore } from '@voicenter-team/events-sdk-vue-3'
import { QueueSDK, QueueCallSDK } from '@voicenter-team/events-sdk'

const queuesStore = useQueuesStore()

// Module-level computeds: shared across all consumers instead of allocated
// per call. Lazy — only evaluate on first `.value` read.
const queues = computed<QueueSDK[]>(() => queuesStore.queuesListAll.value)

const queueWithActiveCalls = computed<QueueSDK[]>(() => {
    return queuesStore.queuesWithActiveCalls.value || []
})

const allQueueCalls = computed<QueueCallSDK[]>(() => {
    return queuesStore.queueCallsAll.value as unknown as QueueCallSDK[] || []
})

export default function useQueues () {
    return {
        queues,
        queueWithActiveCalls,
        allQueueCalls,
    }
}
